import {Container, SectionTitle} from "../../components/LayoutHelpers";
import React from "react";
import "./FAQSection.css"

export default function FAQSection() {
    return <section id="faq" className="section-alt">
        <Container>
            <SectionTitle eyebrow="FAQ" title="Preguntas frecuentes"/>
            <div className="faq">
                <details>
                    <summary>¿Trabajáis con mi stack actual?</summary>
                    <p>Sí. Nuestra premisa es cero fricción: vamos a tus herramientas y las optimizamos.</p></details>
                <details>
                    <summary>¿El RAG es 100% privado?</summary>
                    <p>Se despliega en tu cuenta de AWS (VPC), con cifrado KMS y sin retención de datos.</p></details>
                <details>
                    <summary>¿Cómo medimos el ROI?</summary>
                    <p>Tiempo por tarea, error rate, SLA y € ahorrados. Comparamos antes/después del piloto.</p>
                </details>
                <details>
                    <summary>¿Hacéis proyectos a medida?</summary>
                    <p>Sí. Ofrecemos 'Scope & Build': descubrimiento (precio fijo deducible), alcance por fases y piloto
                        de 2–4 semanas.</p></details>
                <details>
                    <summary>¿Presentáis modelos a Hacienda?</summary>
                    <p>No. Generamos borradores listos para revisión y presentación por gestoría.</p></details>
            </div>
        </Container>
    </section>
}